import { BReactComponent } from 'blocks-cloud/b-react-component';
import _ from 'Cloud/Application/_';
import app from 'Cloud/Application/app';
import config from 'Cloud/config';
import { isPublicUpload, sendPublicUploadRadar } from 'Cloud/ui/PublicUpload';
import { addSmsMessageListener } from 'reactApp/modules/smsSender/smsEventListener';
import { sendLinkBySmsRequest } from 'reactApp/modules/smsSender/smsSender.module';
import { isReactMobilePublic } from 'reactApp/sections/MobilePublicPage/isReactMobilePublic';
import { MobilePublicPage } from 'reactApp/sections/MobilePublicPage/MobilePublicPage';
import { store } from 'reactApp/store';

const IS_PUBLIC = config.get('PUBLIC');
let IS_PUBLIC_FOLDER = config.get('PUBLIC_FOLDER');
let isInited = false;

export const Public = {
    isChoosedPublicFile() {
        return IS_PUBLIC && !IS_PUBLIC_FOLDER;
    },

    isChoosedPublicFolder() {
        return IS_PUBLIC && IS_PUBLIC_FOLDER;
    },

    isPublic() {
        return IS_PUBLIC;
    },

    setChoosedPublicFolder(newValue) {
        IS_PUBLIC_FOLDER = newValue;
    },

    getCanonicalPublicLink() {
        if (!this.isPublic()) {
            return '';
        }

        const item = app.current();

        if (!item) {
            return '';
        }

        const tree = _.tree(app.getStorage());

        if (!tree) {
            return '';
        }

        const ancestors = tree.ancestorsOrSelf(app.current());

        if (!Array.isArray(ancestors) || !ancestors.length) {
            return '';
        }

        let rootId = ancestors[0];

        if (rootId === '/') {
            rootId = ancestors[1];
        }

        if (rootId && rootId !== '/') {
            return rootId;
        }

        return '';
    },
};

export default () => {
    if (!isInited) {
        isInited = true;

        if (IS_PUBLIC) {
            addSmsMessageListener(
                window,
                (phone) => store.dispatch(sendLinkBySmsRequest({ phone, gaCategory: 'publicadv' })),
                'r.mradx.net'
            );
        }

        app.on('page:start', () => {
            if (isReactMobilePublic) {
                const component = new BReactComponent({
                    ReactComponent: MobilePublicPage,
                    renderMode: 'append',
                });

                component.renderTo(document.querySelector('#public-folder-mobile'));

                if (isPublicUpload()) {
                    sendPublicUploadRadar();
                }
            }
        });

        // TODO: убрать везде app.isPublic etc
        Object.assign(app, {
            ...Public,
        });
    }
};
